import * as React from "react";
export class BaseBet extends React.Component {
    constructor(betProps) {
        super(betProps);
        this.ref = React.createRef();
    }
    adjustHeight() {
        this.props.setBetHeight();
    }
    componentDidMount() {
        this.adjustHeight();
    }
    componentDidUpdate() {
        this.adjustHeight();
    }
}
//# sourceMappingURL=BaseBet.js.map